import React from 'react';
import { createRoot } from 'react-dom/client';
import { setConfig } from 'react-hot-loader';
import App from './app';
import { AppInsights, debug } from '@bechtel/client-common';
import { NODE_ENV, DEBUG, AZURE_INSIGHTS_KEY } from '~/env-config';

if (NODE_ENV !== 'production') {
  setConfig({
    reloadHooks: false,
  });
}

if (DEBUG === 'true') {
  if (!localStorage.getItem('debug')) {
    localStorage.setItem('debug', 'bps-web:*');
  }
}

if (NODE_ENV !== 'development' && AZURE_INSIGHTS_KEY) {
  try {
    AppInsights().loadAppInsights();
    AppInsights().trackEvent({ name: 'Application Launch' });
  } catch (error) {
    debug.error(error);
  }
}

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);
